import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef } from 'react';

import { MapContext } from '../../context/map';

const LocationMap = ({ className = 'location-map' }) => {
	const { map, setMap } = useContext(MapContext);
	const ref = useRef();

	useEffect(() => {
		if (ref.current && !map) {
			const center = { lat: 62.905, lng: 16.662 }; // Sweden
			const zoom = 5;

			setTimeout(() => {
				setMap(
					new window.google.maps.Map(ref.current, {
						center,
						fullscreenControl: true,
						gestureHandling: 'cooperative',
						mapTypeControl: false,
						streetViewControl: false,
						zoom,
					}),
				);
			}, 300);
		}

		if (map) {
			const geocoder = new window.google.maps.Geocoder();
			geocoder.geocode({ address: 'Sweden' }, function (results, status) {
				if (status == window.google.maps.GeocoderStatus.OK) {
					map.setCenter(results[0].geometry.location);
					map.fitBounds(results[0].geometry.viewport);
				}
			});
		}
	}, [map, ref, setMap]);

	return <div className={className} ref={ref}></div>;
};

LocationMap.propTypes = {
	className: PropTypes.string,
};

export default LocationMap;
